export default String.raw`
.category-description{
    &__title-container{
        margin: 30px 9%;
        .title{
            font-size: 24px;
            font-weight: 500;
            line-height: 32px;
        }
        .count{
            font-size: 16px;
            line-height: 20px; 
            color: #767676;
        }
    }
    &__container{
        display: flex;
        .description-container{
            background-color: #F1DDDE;
            padding: 80px 30px 80px 9%;
            width: 50%;
            &__category-name{
                font-size: 32px;
                font-weight: 500;
                line-height: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &__description{
                margin-top: 15px;
                font-size: 14px; 
                line-height: 20px; 
                max-height: 100px;
                overflow: auto;
            }
        }
        .image-container{
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
`